module.exports = __webpack_public_path__ + "img/banner.cd09a4eb.jpg";